import { render, staticRenderFns } from "./buttons.vue?vue&type=template&id=6d7b376f&scoped=true&"
import script from "./buttons.vue?vue&type=script&lang=js&"
export * from "./buttons.vue?vue&type=script&lang=js&"
import style0 from "./buttons.vue?vue&type=style&index=0&id=6d7b376f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7b376f",
  null
  
)

export default component.exports